import { environment } from "apps/epims/mrsoftepims/src/environments/environment";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEvent,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AcquisitionGenericService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getAll(type: string, id: string): Observable<any[]> {
    // console.log('type ', id, type)
    return this.http.post<any[]>(this.url + "acquisition-management/type?type=" + type, {id});
  }

  getAllWithoutId(type: string): Observable<any[]> {
    // console.log('type ', type)
    return this.http.post<any[]>(this.url + "acquisition-management/without?type=" + type, {});
  }

  getAllById(type: string, id: string): Observable<any[]> {
    // console.log('type id ', id, type)
    return this.http.post<any[]>(this.url + "acquisition-management/by?type=" + type, {id});
  }

  createData(type: string, data: any[]): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    return this.http.post<any[]>(
      this.url + "acquisition-management/create?type=" + type,
      data,
    );
  }
  getSingleData(type: string, id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    //   let params = new HttpParams();
    //   params = params.append('type', type);
    return this.http.get(this.url + "gateway?type=" + type + id, httpOptions);
  }

  updateData(type: string, data: any[], deletedData: any[]): Observable<any[]> {
    // console.log("Reaching Update function ", type);
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    //   let params = new HttpParams();
    //   params = params.append('type', type);

    let newDataStruct = { data: data, deletedData: deletedData };

    return this.http.post<any[]>(
      this.url + "acquisition-management/gateway-update?type=" + type,
      newDataStruct,
    );
  }

  deleteData(type: string, ids: any) {
    // console.log("Reaching App Delete Service", ids);
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append("stakeholderRef", ids.join(", "));

    return this.http.delete(this.url + "acquisition-management/delete?type=" + type, httpOptions);
  }

  public uploadFile(
    file: File,
    data: any[],
    type: string,
  ): Observable<HttpEvent<{}>> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("Body", JSON.stringify(data));

    // console.log("Reaching Service for Upload", file);

    const options = {
      reportProgress: true,
    };

    const req = new HttpRequest(
      "POST",
      `${this.url + "gateway/createdocument?type=" + type}`,
      formData,
      options,
    );

    // console.log("Http Request ", req);
    return this.http.request(req);

    //   const formData2 = new FormData();
    // formData2.append('file', file);

    // return  this.http.post<any>(this.url  + 'epimsgates/createdocument?type=' + type, formData, {
    //   reportProgress: true,
    //   observe: 'events'
    // });

    //   this.http.get<any>(this.url  + 'epimsgates?type=Document').subscribe((data) => {
    //     console.log("Data from Document Table ", data);
    //   })

    //     return this.http.post<any>(this.url  + 'epimsgates/createdocument?type=' + type, data, {
    //       reportProgress: true,
    //       observe: 'events'
    //     })
  }
}
